import { Route } from '@angular/router'

/**
 * Routes for vulnerability-related components.
 *
 * - **Vulnerability List:** When navigating to the base path (`''`), the `VulnerabilityListComponent` is loaded.
 * - **Vulnerability Details:** When navigating to the `/details` path, the `VulnerabilityDetailsComponent` is loaded.
 */
export const VULNERABILITY: Route[] = [
    {
        path: '',
        loadComponent: () =>
            import('../vulnerability/vulnerability-list/vulnerability-list.component').then(
                (c) => c.VulnerabilityListComponent
            ),
    },
    {
        path: 'details',
        loadComponent: () =>
            import('../vulnerability/vulnerability-details/vulnerability-details.component').then(
                (c) => c.VulnerabilityDetailsComponent
            ),
    },
]
